var map = {
	"./2-1@2x.png": "f2c3",
	"./2-2@2x.png": "8a01",
	"./2-3@2x.png": "7600",
	"./2-4@2x.png": "5ca5",
	"./5g/2-1@2x.png": "c954",
	"./5g/2-2@2x.png": "95e0",
	"./5g/2-3@2x.png": "325b",
	"./5g/2-4@2x.png": "463b",
	"./5g/banner-3-1@2x.jpg": "6004",
	"./5g/banner-3-2@2x.jpg": "6d76",
	"./5g/banner-3-3@2x.jpg": "8c59",
	"./5g/framework.png": "08e3",
	"./Logisticsadvertising/2-1@2x.png": "b990",
	"./Logisticsadvertising/2-2@2x.png": "8f0e",
	"./Logisticsadvertising/2-3@2x.png": "a660",
	"./Logisticsadvertising/banner-3-1@2x.jpg": "fdea",
	"./Logisticsadvertising/banner-3-2@2x.jpg": "ea36",
	"./Logisticsadvertising/framework.png": "ce43",
	"./Smartfarm/2-1@2x.png": "497b",
	"./Smartfarm/2-2@2x.png": "72b0",
	"./Smartfarm/2-3@2x.png": "3f74",
	"./Smartfarm/banner-3-1@1x.jpg": "ed7b",
	"./Smartfarm/banner-3-2@1x.jpg": "0121",
	"./Smartfarm/framework.png": "cfe2",
	"./Valuesupplychain/2-1@2x.png": "f190",
	"./Valuesupplychain/2-2@2x.png": "58ba",
	"./Valuesupplychain/2-3@2x.png": "0475",
	"./Valuesupplychain/2-4@2x.png": "c584",
	"./Valuesupplychain/banner-3-1@2x.jpg": "49ae",
	"./Valuesupplychain/banner-3-2@2x.jpg": "1ce7",
	"./Valuesupplychain/banner-3-3@2x.jpg": "e149",
	"./Valuesupplychain/banner-3-4@2x.jpg": "7689",
	"./Valuesupplychain/framework.png": "90ed",
	"./banner.jpg": "bf45",
	"./bg-1.jpg": "2190",
	"./bg-2.jpg": "0873",
	"./bg-3.png": "eeb1",
	"./data.png": "2bac",
	"./digitalfleet/2-1@2x.png": "65c9",
	"./digitalfleet/2-2@2x.png": "bdd1",
	"./digitalfleet/2-3@2x.png": "527c",
	"./digitalfleet/2-4@2x.png": "f011",
	"./digitalfleet/banner-3-1@2x.jpg": "3640",
	"./digitalfleet/banner-3-2@2x.jpg": "9625",
	"./digitalfleet/banner-3-3@2x.jpg": "bf80",
	"./digitalfleet/banner-3-4@2x.jpg": "ad68",
	"./digitalfleet/framework.png": "9e8f",
	"./scene1.jpg": "8ee4",
	"./scene2.jpg": "1fc8",
	"./scene3.jpg": "89fb",
	"./scene4.jpg": "f3fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a529";